import { DetailedUser, useRepositoryMutation } from '@mews-commander/data-access';
import { AuthorizedDeviceList } from '../../../../auth';

export function UserAuthorizedDevices({ user }: { user: DetailedUser }) {
    const { isPending, mutate: onUserRemove } = useRepositoryMutation('deviceAuthorization', 'unauthorizeUserDevice', {
        invalidateQueries: {
            userProfiles: ['get'],
        },
    });

    return (
        <AuthorizedDeviceList
            isPending={isPending}
            devices={user.userDevices}
            onUserRemove={(deviceId) => onUserRemove({ deviceId, userId: user.userId })}
        />
    );
}
